import { useId } from "react";
import { OTP_LENGTH } from "../lib/env";

interface OtpInputProps {
  value: string;
  onChange: (next: string) => void;
  label: string;
  placeholder?: string;
  disabled?: boolean;
  error?: string | null;
  autoFocus?: boolean;
}

export function OtpInput({
  value,
  onChange,
  label,
  placeholder,
  disabled = false,
  error,
  autoFocus = false,
}: OtpInputProps): JSX.Element {
  const inputId: string = useId();
  const helperId: string = `${inputId}-helper`;
  const hasError: boolean = error != null && error !== "";
  return (
    <div className={`field${hasError ? " field--error" : ""}`}>
      <label htmlFor={inputId} className="field__label">
        {label}
      </label>
      <input
        id={inputId}
        className="field__input field__input--otp"
        inputMode="numeric"
        pattern="[0-9]*"
        autoComplete="one-time-code"
        autoFocus={autoFocus}
        maxLength={OTP_LENGTH}
        placeholder={placeholder}
        disabled={disabled}
        value={value}
        aria-invalid={hasError || undefined}
        aria-describedby={hasError ? helperId : undefined}
        onChange={(event) => {
          const sanitized: string = event.target.value
            .replace(/\D/g, "")
            .slice(0, OTP_LENGTH);
          onChange(sanitized);
        }}
      />
      {hasError ? (
        <p id={helperId} className="field__error" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
